function edQuickAdd() {
  var $formContainer = $(".block-inner-inner");
  $formContainer.find("form.ed-quickadd-form").each(function () {
    var $form = $(this);
    var addBtn = $form.find(".js-go-cart-add-to-cart.svgcart");
    $form.on("submit", function (evt) {
      // Ajax-add
      if (theme.settings.after_add_to_cart !== "no-js") {
        evt.preventDefault();
        var shopifyAjaxAddURL = theme.routes.cart_add_url;
        //Disable add button
        $form
          .find('button[type="submit"]')
          .attr("disabled", "disabled")
          .each(function () {
            if ($(this).hasClass("btn--added")) {
              clearTimeout($(this).data("revertAddToCartTextTimeoutID"));
            } else {
              $(this).data("previous-value", $(this).html());
            }
          })
          .html('<div class="loading-spinner loading-spinner--in-btn"></div>');

        $form.find('button[type="submit"]').each(function () {
          setTimeout(() => {
            $(this).html(addBtn);
          }, 6000);
        });

        //Add to cart
        var formData = new FormData($form[0]);
        formData.append("sections", "cart-drawer");

        setTimeout(function () {
          let upsellBtns = document.querySelectorAll(".upsellbtn");
          let upsellScroller = document.querySelector(".ed-cart-upsell");
          let childWidth = upsellScroller.children[0].offsetWidth;

          function upsellScrollerFunc(upsellBtn) {
            if (upsellBtn.id == "left-scroll") {
              upsellScroller.style.scrollBehavior = "smooth";
              upsellScroller.scrollLeft -= childWidth;
              upsellScroller.style.scrollBehavior = "unset";
            } else if (upsellBtn.id == "right-scroll") {
              upsellScroller.style.scrollBehavior = "smooth";
              upsellScroller.scrollLeft += childWidth;
              upsellScroller.style.scrollBehavior = "unset";
            }
          }

          for (let upsellBtn of upsellBtns) {
            upsellBtn.addEventListener("click", function () {
              upsellScrollerFunc(upsellBtn);
            });
          }
        }, 2500);

        $.post(
          shopifyAjaxAddURL,
          new URLSearchParams(formData).toString(),
          theme.addedToCartHandler.bind($form),
          "json",
        ).fail(function (data) {
          //Enable add button
          $form
            .find('button[type="submit"]')
            .removeAttr("disabled")
            .each(function () {
              setTimeout(() => {
                $(this).html(addBtn);
              }, 3500);
            });
          //Not added, show message
          if (
            typeof data !== "undefined" &&
            typeof data.status !== "undefined"
          ) {
            var jsonRes = $.parseJSON(data.responseText);
            theme.showQuickPopup(
              jsonRes.description,
              $form.find('button[type="submit"]:first'),
            );
          } else {
            //Some unknown error? Disable ajax and add the old-fashioned way.
            $formContainer.attr("ajax-add-to-cart", "false");
            $form.submit();
          }
        });
      }
    });
  });

  var ccCollectionSelectBtns = document.querySelectorAll(
    ".cc-select__button.collection",
  );
  var ccCollectionSelectOptions = document.querySelectorAll(
    ".cc-select__option.js-option.product-block-edition",
  );
  if (ccCollectionSelectBtns) {
    var parentContainers = document.querySelectorAll(".product-block");
    for (var parentContainer of parentContainers) {
      parentContainer.addEventListener("mouseenter", function () {
        event.stopPropagation();
        var formParent = this.querySelector(".ed-quickadd");
        var selectParent = formParent.querySelector(
          ".cc-select__listbox.product-block-edition",
        );
        selectParent.style.visibility = "hidden";
      });
    }

    for (var ccCollectionSelectBtns of ccCollectionSelectBtns) {
      ccCollectionSelectBtns.addEventListener("click", function () {
        var formParent = this.closest(".ed-quickadd");
        var selectParent = formParent.querySelector(
          ".cc-select__listbox.product-block-edition",
        );
        var listBoxEles = document.querySelectorAll(
          ".cc-select__listbox.product-block-edition",
        );
        for (var listBoxEle of listBoxEles) {
          listBoxEle.style.visibility = "hidden";
        }
        selectParent.style.visibility = "visible";
      });
    }

    // check that url does not contain "products"
    var url = window.location.href;
    for (var ccCollectionSelectOption of ccCollectionSelectOptions) {
      ccCollectionSelectOption.addEventListener("click", function () {
        var optionValue = this.getAttribute("value");
        var optionName = this.getAttribute("data-name");

        if (this.getAttribute("data-udsolgt") === "true") {
          var variantUrl = this.getAttribute("data-url");
          if (variantUrl) {
            window.location.href = variantUrl;
          }
        } else {
          var parentEle = this.closest(".ed-quickadd");
          var addToCart = parentEle.querySelector(".js-go-cart-add-to-cart");
          var iconAddtoCart = parentEle.querySelector(
            ".js-go-cart-add-to-cart.svgcart",
          );
          var idInput = parentEle.querySelector(".product-select");
          var formId = this.closest(".ed-quickadd-form");
          var formIdCurrent = this.getAttribute("id");
          var formIdNew = formIdCurrent + optionValue + optionValue;

          idInput.value = optionValue;
          formId.setAttribute("id", formIdNew);
          if (optionValue.value == "Vælg størrelse") {
            addToCart.setAttribute("disabled", "disabled");
            iconAddtoCart.style.pointerEvents = "none";
          } else {
            addToCart.removeAttribute("disabled");
            iconAddtoCart.style.pointerEvents = "auto";
          }
        }
        var parentEle = this.closest(".ed-quickadd");
        var selectList = parentEle.querySelector(
          ".cc-select__listbox.product-block-edition",
        );
        selectList.style.visibility = "hidden";
        var selectButton = parentEle.querySelector(
          ".cc-select__button.collection",
        );
        setTimeout(() => {
          optionArrName = optionName.split("-");
          if (optionArrName[1] !== undefined) {
            selectButton.innerHTML = `<span class="tw-font-medium">${optionArrName[0]}</span> <span>${optionArrName[1]}</span>`;
          } else {
            selectButton.innerHTML = `<span class="tw-font-medium">${optionArrName[0]}</span>`;
          }
        }, 1);
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(() => {
    edQuickAdd();
  }, 1000);
});

// fejl meddelelse hvis en besøgende prøver at tilmelde sig nyhedsbrevet med en email der allerede er tilmeldt
var urlNoSignup = window.location.href;
var newsletterForm = document.getElementById("cc-popup");
var footerNewsletterForm = document.getElementById("footer_newsletter_signup");

if (newsletterForm) {
  newsletterForm.addEventListener("submit", function (event) {
    localStorage.setItem("formSubmitted", "true");
  });
}

if (footerNewsletterForm) {
  footerNewsletterForm.addEventListener("submit", function (event) {
    localStorage.setItem("formSubmitted", "true");
  });
}

if (localStorage.getItem("formSubmitted")) {
  if (
    urlNoSignup.includes("?contact%5Btags%") ||
    urlNoSignup.includes("?%5Bnote") ||
    urlNoSignup.includes("%5Bnote")
  ) {
    var newPopup = document.querySelector(
      ".section-popup.cc-popup.cc-popup--center",
    );
    if (newPopup) {
      newPopup.classList.add("cc-popup--visible");
      var popupTextWrapper = document.querySelector(".cc-popup-text");
      var currentError = document.querySelector(".error-message");
      var errorMessage = document.createElement("div");
      var errorMessageText = document.createElement("div");
      errorMessage.classList.add("cc-popup-form__response-ed");
      errorMessage.classList.add("cc-popup-form__response--error");
      errorMessageText.classList.add("error-message");
      errorMessageText.style.color = "red";
      errorMessage.appendChild(errorMessageText);
      popupTextWrapper.appendChild(errorMessage);
      if (currentError) {
        currentError.remove();
      }

      errorMessageText.innerHTML = "Denne e-mail er allerede tilmeldt.";
      errorMessage.style.margin = "0";

      var emptyEmailMessageError = document.querySelector(
        ".cc-popup-form__response.cc-popup-form__response--error",
      );
      emptyEmailMessageError.remove();
      localStorage.removeItem("formSubmitted");
    } else {
      alert("Denne e-mail er allerede tilmeldt.");
      localStorage.removeItem("formSubmitted");
    }
  }
}

// check "in stock" hvis der klikkes på et størrelsesfilter

function filterCheck() {
  const checkboxes = document.querySelectorAll(
    'input[type="checkbox"][name="filter.v.option.størrelse"]',
  );
  let isChecked = false;

  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      isChecked = true;
    }
  });

  if (isChecked) {
    document.getElementById("Filter-filter.v.availability-2").click();
  } else {
    document.getElementById("Filter-filter.v.availability-1").click();
  }
}

// readmore on collctions
var readmore = document.querySelector("#read_more");
var fullDescription = document.querySelector("#full_description");

if (readmore) {
  readmore.addEventListener("click", function () {
    var scrollOffset =
      fullDescription.getBoundingClientRect().top + window.pageYOffset - 150;
    window.scrollTo({ top: scrollOffset, behavior: "smooth" });
  });
}

$(function () {
  // Display Sold-out text on dropdown-button.
  const listItems = document.querySelectorAll(
    ".input-row li.cc-select__option",
  );
  const button = document.querySelector(".input-row button.cc-select__btn");
  const addToCartBtn = document.querySelector("#AddToCart");
  const preorderBox = document.querySelector(".button__preorder");
  const dropdownArrow =
    '<svg class="cc-select__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';

  listItems.forEach((item) => {
    if (item.getAttribute("aria-selected")) {
      let statusText = "";
      if (item.classList.contains("is-unavailable")) {
        statusText =
          '<span class="sold-out-label" style="margin-left: auto; display: flex; align-items: center;">' +
          theme.strings.products_labels_sold_out;
      }

      if (item.dataset.preorder == "true") {
        preorderText = `<span> ${theme.strings.products_preorder}</span>`;
      } else {
        preorderText = "";
      }

      button.innerHTML =
        '<span class="tw-font-medium">' +
        item.dataset.value +
        "</span>" +
        statusText +
        preorderText +
        dropdownArrow;
    }

    item.addEventListener("click", (e) => {
      let statusText = "";
      if (item.classList.contains("is-unavailable")) {
        statusText =
          '<span class="sold-out-label" style="margin-left: auto; display: flex; align-items: center;">' +
          theme.strings.products_labels_sold_out +
          ' <span class="tilmeld-liste"><a href="#" class="BIS_trigger" style="display: flex; align-items: center; text-decoration: underline !important; cursor: pointer;"><img height="15" width="15" style="margin: 0 5px;" src="https://cdn.shopify.com/s/files/1/0612/2258/4473/files/mail.png?v=1653398586" alt=""> ' +
          theme.strings.products_labels_be_notified +
          "</a></span</span>";
      }

      if (
        item.dataset.preorder == "true" &&
        !item.classList.contains("is-unavailable")
      ) {
        preorderBox.style.display = "flex";
        // set this attribute to "pre_order"

        //settimeout 500ms
        setTimeout(() => {
          addToCartBtn.innerHTML = theme.strings.products_preorder;
        }, 50);
      } else if (item.classList.contains("is-unavailable")) {
        preorderBox.style.display = "none";
        setTimeout(() => {
          addToCartBtn.innerHTML = theme.strings.products_labels_sold_out;
        }, 50);
      } else {
        preorderBox.style.display = "none";
        setTimeout(() => {
          addToCartBtn.innerHTML = theme.strings.products_product_add_to_cart;
        }, 50);
      }

      if (item.dataset.preorderinfo != "") {
        preorderBox.querySelector("p.product__preorder-content").innerHTML =
          item.dataset.preorderinfo;
      }

      if (
        item.dataset.preorder == "true" &&
        !item.classList.contains("is-unavailable")
      ) {
        button.innerHTML =
          '<span class="tw-font-medium">' +
          item.dataset.value +
          "</span>" +
          statusText +
          preorderText +
          dropdownArrow;
      } else {
        button.innerHTML =
          '<span class="tw-font-medium">' +
          item.dataset.value +
          "</span>" +
          statusText +
          dropdownArrow;
      }
    });
  }); /* listItems.foreach */

  // $("body").on("click", ".cc-select__option", (event) => {
  //   if ($(event.currentTarget).has("span.sold-out-label").length != 0) {
  //     $("#BIS_trigger").click();
  //     document.querySelector(".buy-buttons-row #BIS_trigger").style.display =
  //       "block";
  //   } else {
  //     document.querySelector(".buy-buttons-row #BIS_trigger").style.display =
  //       "none";
  //   }
  // });
  /* Offcanvas preorder */
  // Open offcanvas.
  $(".button__preorder").click(() => {
    // Disable page-scroll
    $("html, body").css({
      overflow: "hidden",
      height: "100%",
    });
    $(".offcanvas__preorder").animate({
      left: "0",
    });
    $(".offcanvas__overlay").fadeIn();
  });

  // Close offcanvas.
  $(".button__preorder__close").click(() => {
    // Enable page-scroll
    $("html, body").css({
      overflow: "auto",
      height: "auto",
    });
    $(".offcanvas__preorder").animate({
      left: "-500px",
    });
    $(".offcanvas__overlay").fadeOut();
  });

  // Close offcanvas
  $(".offcanvas__overlay").click(() => {
    // Enable page-scroll
    $("html, body").css({
      overflow: "auto",
      height: "auto",
    });
    $(".offcanvas__preorder").animate({
      left: "-500px",
    });
    $(".offcanvas__overlay").fadeOut();
  });

  //   if ($("body").hasClass("template-product")) {
  //     $.get( "https://club.shophelten.dk/rest-api/information.php?shop_id=fashion-by-strand.myshopify.com", function( data ) {
  //       const data_json = JSON.parse(data);
  //       const percentage = data_json.shop_bonus_percentage;

  //     });
  //   }
});

let upsellBtns = document.querySelectorAll(".upsellbtn");
let upsellScroller = document.querySelector(".ed-cart-upsell");
let childWidth = upsellScroller.children[0].offsetWidth;

function upsellScrollerFunc(upsellBtn) {
  if (upsellBtn.id == "left-scroll") {
    upsellScroller.style.scrollBehavior = "smooth";
    upsellScroller.scrollLeft -= childWidth;
    upsellScroller.style.scrollBehavior = "unset";
  } else if (upsellBtn.id == "right-scroll") {
    upsellScroller.style.scrollBehavior = "smooth";
    upsellScroller.scrollLeft += childWidth;
    upsellScroller.style.scrollBehavior = "unset";
  }
}

for (let upsellBtn of upsellBtns) {
  upsellBtn.addEventListener("click", function () {
    upsellScrollerFunc(upsellBtn);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".Avada-CookiesFloat_DenyButtonText")) {
      document.querySelector(".Avada-CookiesFloat_BtnAgree").click();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".Avada-CookiesMobile_DenyButtonText")) {
      document.querySelector(".Avada-CookiesMobile_BtnAgree").click();
    }
  });
});

// Testimonial Slider Section

class testimonalSection extends HTMLElement {
  constructor() {
    super();

    const testimonialSlider = this;
    const testimonialSliderCards = this.querySelectorAll(".card_slide");
    const sliderCardsWidth = testimonialSliderCards[0].offsetWidth + 35;

    const sliderBtns =
      this.closest(".slidercontainered").querySelectorAll(".sliderbtn");

    for (let sliderBtn of sliderBtns) {
      sliderBtn.addEventListener("click", function () {
        if (sliderBtn.getAttribute("data-id") == "right") {
          testimonialSlider.scrollLeft += sliderCardsWidth;
        } else {
          testimonialSlider.scrollLeft -= sliderCardsWidth;
        }
      });
    }
  }
}

customElements.define("ed-testimonial-slider", testimonalSection);

function initializeCartUpdateListener() {
  document.documentElement.dispatchEvent(
    new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false }),
  );
}

function initializeCartUpdateListener() {
  document.documentElement.dispatchEvent(
    new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false }),
  );
  console.log("cart changed");
}

window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    setTimeout(() => {
      initializeCartUpdateListener();
    }, 1500);
  }
});

//pop up

class PopUpMultipleSize extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".popup__content");
    this.cartContent =
      document.querySelector("cart-form .CartDrawer-Content_blur") ||
      document.querySelector(".CartDrawer-Content_blur");

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.isOpen = false;
    this.exceeds = false; // <- track whether we should show at all

    this.sizeVariants = {};
    this._refreshTimeout = null;
  }

  connectedCallback() {
    // Initial fetch + UI state
    this.refreshFromCart();

    // Keep in sync with cart updates
    document.addEventListener("theme:cartchanged", () =>
      this.refreshFromCart(),
    );
    document.addEventListener("cart:updated", () => this.refreshFromCart());
    document.addEventListener("cart:change", () => this.refreshFromCart());

    // (Optional) if your theme fires on load:
    document.addEventListener("DOMContentLoaded", () => this.refreshFromCart());

    // Summary toggle
    if (this.summary) {
      this.summary.addEventListener("click", (e) => this.togglePopover(e));
    }

    // Close button removes blur
    const cartCloseButton = document.querySelector(".cc-popup-close");
    if (cartCloseButton) {
      cartCloseButton.addEventListener("click", () => this.removeBlurEffect());
    }

    // IMPORTANT: do NOT auto-open here anymore
    // If you really want auto-open, do it ONLY when exceeds (see updateSizeWarningUI).
  }

  refreshFromCart() {
    clearTimeout(this._refreshTimeout);
    this._refreshTimeout = setTimeout(async () => {
      try {
        const res = await fetch("/cart.js", { credentials: "same-origin" });
        const cart = await res.json();
        this.sizeVariants = this.computeSizeVariants(cart.items);
        window.sizeVariants = this.sizeVariants; // if you still want it globally
        this.updateSizeWarningUI();

        // Re-render popup content to show updated fit information
        await this.reRenderPopupContent();
      } catch (e) {
        console.warn("Failed to refresh cart:", e);
        // Fail-safe: hide + unblur
        this.exceeds = false;
        this.hideAndUnblur();
      }
    }, 60);
  }

  async reRenderPopupContent() {
    try {
      // Determine if we're in cart drawer or cart page
      const isInCartDrawer = this.closest('[data-section-type="cart-drawer"]');
      let url;

      if (isInCartDrawer) {
        // For cart drawer, fetch the section specifically
        const sectionId = this.closest('[data-section-type="cart-drawer"]')
          ?.dataset?.sectionId;
        url = sectionId
          ? `${window.Shopify.routes.root}?section_id=${sectionId}`
          : "/cart";
      } else {
        // For cart page, fetch the current page
        url = window.location.href;
      }

      const response = await fetch(url, {
        credentials: "same-origin",
      });
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find the fresh popup content
      const freshPopup = doc.querySelector(
        "pop-up-multiple-size .popup__content",
      );
      const currentPopup = this.querySelector(".popup__content");

      if (freshPopup && currentPopup) {
        currentPopup.innerHTML = freshPopup.innerHTML;
      }
    } catch (error) {
      console.warn("Failed to re-render popup content:", error);
    }
  }

  /** Build handle -> unique sizes[] from current cart items */
  computeSizeVariants(items = []) {
    const map = {};
    for (const item of items) {
      const handle =
        item.product_handle ||
        item.handle ||
        (item.product && item.product.handle) ||
        "";
      if (!handle) continue;

      // Try to find an option named "Size" (case-insensitive). Fallback to first option.
      let sizeValue = null;

      if (
        Array.isArray(item.options_with_values) &&
        item.options_with_values.length
      ) {
        const sizeOpt =
          item.options_with_values.find(
            (ov) => (ov.name || "").toLowerCase() === "size",
          ) || item.options_with_values[0];

        sizeValue = sizeOpt?.value ?? null;
      } else if (Array.isArray(item.options) && item.options.length) {
        sizeValue = item.options[0];
      }

      if (!sizeValue) continue;

      if (!map[handle]) map[handle] = new Set();
      map[handle].add(String(sizeValue));
    }

    // Convert Set -> Array
    const out = {};
    Object.keys(map).forEach((h) => (out[h] = Array.from(map[h])));
    return out;
  }

  /** Read threshold + update visibility; auto-close/clear blur if not exceeding */
  updateSizeWarningUI() {
    const thresholdAttr =
      this.dataset.popupThreshold ||
      this.getAttribute("data-popup-threshold") ||
      "0";
    const popupThreshold = parseInt(thresholdAttr, 10) || 0;

    this.exceeds = Object.values(this.sizeVariants).some(
      (sizes) => sizes.length > popupThreshold,
    );

    // Show/Hide host
    this.style.display = this.exceeds ? "block" : "none";

    // Show/Hide info box
    const infoBox = document.querySelector("[data-popup-info-box]");
    if (infoBox) {
      infoBox.style.display = this.exceeds ? "block" : "none";
    }

    // If it shouldn't be shown, ensure it is closed and unblurred
    if (!this.exceeds) {
      this.hideAndUnblur();
      return;
    }

    // Optional: auto-open only when it *should* be shown
    // If you DON'T want auto-open at all, comment these lines.
    if (!this.isOpen && !this.details.open) {
      // Give the browser a tick so DOM is painted before animating
      requestAnimationFrame(() => this.open());
    }
  }

  hideAndUnblur() {
    if (this.details) {
      this.details.open = false;
      this.details.style.height = "";
      this.details.style.overflow = "";
    }
    this.isOpen = false;
    this.isClosing = false;
    this.isExpanding = false;
    this.animation?.cancel?.();
    this.removeBlurEffect();
  }

  togglePopover() {
    // Guard: do nothing if not supposed to be visible
    if (!this.exceeds) return;

    this.details.style.overflow = "hidden";

    if (!this.details.open) {
      this.open();
    } else {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: "ease" },
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    if (!this.exceeds || this.style.display === "none") return;

    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;

    // (optional soft attempt – okay to remove)
    // setTimeout(() => {
    //   if (this.exceeds && this.details.open) this.applyBlurEffect();
    // }, 50);

    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight +
      parseInt(summaryStyle.marginTop) +
      this.content.offsetHeight
    }px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 400, easing: "ease-out" },
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = this.details.style.overflow = "";

    if (open) {
      this.isOpen = true;
      this.applyBlurEffect(); // <- move blur here
    } else {
      this.isOpen = false;
      this.removeBlurEffect();
    }
  }

  applyBlurEffect() {
    // Blur effect disabled - allow cart interaction
    return;
  }

  removeBlurEffect() {
    // Blur effect disabled - allow cart interaction
    return;
  }

  /** If you still want this, fix the typo and make it read-only */
  toggleSizeWarning() {
    const sizeEl = this.querySelector("[data-variant-size]");
    const threshEl = this.querySelector("[data-popup-threshold]");
    if (!sizeEl || !threshEl) return;

    const variantSize = Number(sizeEl.dataset.variantSize || 0);
    const popupThreshold = Number(threshEl.dataset.popupThreshold || 0);

    if (variantSize > popupThreshold) {
      const block = this.querySelector(".cart-multiple-sizes");
      if (!block) return;
      block.style.display =
        block.style.display === "none" || !block.style.display
          ? "block"
          : "none";
    } else {
      // ensure hidden + unblur if not eligible
      const block = this.querySelector(".cart-multiple-sizes");
      if (block) block.style.display = "none";
      this.hideAndUnblur();
    }
  }

  setBackgroundColor(color) {
    this.style.backgroundColor = color;
  }
}

customElements.define("pop-up-multiple-size", PopUpMultipleSize);
